/**
 * SearchContent component.
 */
import Container from '@components/atoms/container/searchContentContainer';
import Direction from '@shared/types/enums/direction';
import FocusUtils from '@shared/utils/focus';
import Focus from '@shared/types/enums/focus';
import List from '@components/sections/list/railsList/railsList';
import MainContext from '@shared/components/utils/context/mainContext';
import VerticalAnimationContainer from '@components/atoms/container/verticalAnimationContainer';
import useTransform from '@shared/components/utils/hooks/useTransform';
import { focusSelector } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useContext, useEffect, useRef, useState } from 'react';

/**
 * Constants.
 *
 * @constant {number} OFFSET - Vertical offset for the search content.
 */
const OFFSET = 350;

/**
 * SearchContent component.
 *
 * @param {Rail[]} rails - The rails to display.
 * @returns {React.ReactNode} The SearchContent component.
 */
export default function SearchContent() {
  const { rails } = useContext(MainContext);
  const { focus } = useAppSelector(focusSelector);
  const currentRailRef = useRef(0);
  const [animation, setAnimation] = useState('search-rails-scroll-down');
  const [style, , , changeStyle] = useTransform(0, OFFSET, Direction.VERTICAL);

  useEffect(() => {
    if (
      FocusUtils.evaluateFocus(Focus.RAILS_LIST) ||
      focus === Focus.MODAL_INPUT ||
      focus === Focus.FLOATING_MENU
    ) {
      setAnimation('search-rails-scroll-down');
      setTimeout(() => {
        changeStyle(0);
      });
    } else {
      setAnimation('search-rails-scroll-up');
      setTimeout(() => {
        changeStyle(1);
      });
    }
  }, [focus]);

  return rails?.length ? (
    <VerticalAnimationContainer animation={animation} style={style}>
      <Container>
        <List currentRail={currentRailRef} rails={rails} />
      </Container>
    </VerticalAnimationContainer>
  ) : null;
}
